export const getStartedGame = (game, players) => ({
  ...game,
  players,
  nextTurn: {
    ...game.golf.nextTurn,
    // Swapping user id for the username so it is printed in the UI
    players: game.golf.nextTurn.players.map(
      (player) =>
        game.players.find(({ user }) => user.id === player).user.username
    ),
  },
  pickedUpCard: getPickedUpCard(players),
  discardCard: game.golf.publicView.discardPileCard,
  isRoundComplete: isRoundComplete(game),
})

const getPickedUpCard = (players) => {
  const hasPickedUpCard = players.away
    .concat(players.home)
    .find((itm) => !!Number.isInteger(itm.pickedUpCard))
  return hasPickedUpCard ? hasPickedUpCard.pickedUpCard : null
}

/**
 * Splits players between home (the currently logged in player) and away (other users) based on the homeUser
 * @param {object} game: the current game
 * @param {string} homeUser: the user id for the home player
 */
export const getPlayers = ({
  game: {
    players,
    golf: { publicView, nextTurn = { players: [], actions: [] } },
  },
  homeUser,
}) => {
  const playersGameScores = getPlayersGameScores({ players })
  const roundScoresAsc = players
    .map(({ score }) => score.slice(-1)[0])
    .sort((a, b) => a - b)
  const { 0: topRoundScore } = roundScoresAsc
  return players.reduce(
    (acc, { score, user: { id, username } }) => {
      const { isGameWinner, isGameLoser, totalScore } = playersGameScores.find(
        (itm) => itm.id === id
      )
      const isHomeUser = homeUser === id
      const player = {
        id,
        isGameWinner,
        isGameLoser,
        isRoundWinner: score.slice(-1)[0] === topRoundScore,
        visibleCards: publicView.players.find((itm) => id === itm.id).cards,
        pickedUpCard: publicView.players.find((itm) => id === itm.id)
          .pickedUpCard,
        username,
        totalScore,
        score,
        actions:
          nextTurn && nextTurn.players.includes(id) ? nextTurn.actions : [],
      }
      if (isHomeUser) return { ...acc, home: player }
      return { ...acc, away: acc.away.concat(player) }
    },
    { away: [] }
  )
}

export const isRoundComplete = (game) =>
  game?.golf?.publicView?.players?.every(({ cards }) =>
    cards.every((i) => Number.isInteger(i))
  )

export const getPlayersGameScores = ({ players }) => {
  const gameScoresAsc = players
    .map(({ score }) => score.reduce((acc, itm) => itm + acc, 0))
    .sort((a, b) => a - b)
  const { 0: topGameScore, [gameScoresAsc.length - 1]: bottomGameScore } =
    gameScoresAsc

  return players.map(({ score, user: { id, username } }) => {
    const totalScore = score.reduce((acc, itm) => acc + itm, 0)
    const isGameWinner = totalScore === topGameScore
    const isGameLoser = totalScore === bottomGameScore
    return {
      id,
      username,
      totalScore,
      isGameWinner,
      isGameLoser,
    }
  })
}
